// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"az_nw"};